import { Image as MantineImage, ImageProps as MantineImageProps } from '@mantine/core';
import { Image as UnpicImage, ImageProps as UnpicImageProps } from '@unpic/react';

import { useFileAccessSrc } from '../../../hooks/useFileAccessSrc';

type UnpicVariantProps = { variant: 'unpic' } & Omit<UnpicImageProps, 'src'> & { src: string };

type MantineVariantProps = { variant: 'mantine' } & Omit<MantineImageProps, 'src'> & {
    src: string;
    alt?: string;
    width?: number;
    height?: number;
  };

type AccessControlledImageProps = (UnpicVariantProps | MantineVariantProps) & { dataTestId?: string };

export function AccessControlledImage(props: AccessControlledImageProps) {
  const { src, variant, dataTestId, ...rest } = props;

  const { src: displaySrc, isLoading } = useFileAccessSrc(src);

  if (isLoading || !displaySrc) {
    return null;
  }

  return variant === 'unpic' ? (
    <UnpicImage {...(rest as UnpicImageProps)} src={displaySrc} data-testid={dataTestId} />
  ) : (
    <MantineImage {...rest} src={displaySrc} data-testid={dataTestId} />
  );
}
